var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2915 12.1367V10.5509C2.2915 8.65336 3.84067 7.10419 5.73817 7.10419H16.2615C18.159 7.10419 19.7082 8.65336 19.7082 10.5509V11.8709H17.8565C17.3432 11.8709 16.8757 12.0725 16.5365 12.4208C16.1515 12.7967 15.9315 13.3375 15.9865 13.915C16.069 14.905 16.9765 15.6292 17.9665 15.6292H19.7082V16.72C19.7082 18.6175 18.159 20.1667 16.2615 20.1667H11.2382",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2915 11.3758V7.1867C2.2915 6.09587 2.96067 5.12416 3.97817 4.73916L11.2565 1.98916C12.3932 1.55833 13.6123 2.40169 13.6123 3.62085V7.10418",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6787 12.806V14.6944C20.6787 15.1985 20.2754 15.611 19.7621 15.6293H17.9654C16.9754 15.6293 16.0679 14.9052 15.9854 13.9152C15.9304 13.3377 16.1504 12.7968 16.5354 12.421C16.8746 12.0727 17.3421 11.871 17.8554 11.871H19.7621C20.2754 11.8894 20.6787 12.3018 20.6787 12.806Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 11H12.8332",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15.125H7.645C8.23166 15.125 8.70833 15.6016 8.70833 16.1883V17.3617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86833 14.0067L2.75 15.125L3.86833 16.2433",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70833 19.9651H3.81334C3.22667 19.9651 2.75 19.4884 2.75 18.9017V17.7284",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59131 21.0837L8.70964 19.9653L7.59131 18.847",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.a665e1958083c1dd42045898bbffa4fc.svg";
export { ForwardRef as ReactComponent };